import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function resolveRange(key, cs, ce) {
  const now = new Date();
  if (key === "this_month") return { start: new Date(now.getFullYear(), now.getMonth(), 1), end: now };
  if (key === "last_month") return { start: new Date(now.getFullYear(), now.getMonth() - 1, 1), end: new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59) };
  if (key === "last_30") { const s = new Date(now); s.setDate(s.getDate() - 30); return { start: s, end: now }; }
  const start = cs ? new Date(cs + "T00:00:00") : new Date(now.getFullYear(), now.getMonth(), 1);
  const end = ce ? new Date(ce + "T23:59:59") : now;
  return { start, end };
}

export function exportCsv(filename, headers, rows) {
  const esc = (v) => {
    const s = String(v ?? "");
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [headers.map(esc).join(","), ...rows.map((r) => r.map(esc).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function fmtWhen(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch { return "—"; }
}

export const RCard = ({ children, className = "", ...rest }) => (
  <div {...rest} className={`bg-white rounded-2xl border border-sand-200 shadow-[0_4px_20px_-8px_rgba(0,0,0,0.08)] ${className}`}>{children}</div>
);

export const Tile = ({ label, value, sub, testid }) => (
  <RCard className="p-4" data-testid={testid}>
    <div className="text-[11px] font-bold tracking-[0.12em] text-ink-400 uppercase">{label}</div>
    <div className="font-heading text-2xl font-extrabold text-ink mt-1">{value}</div>
    {sub && <div className="text-xs text-ink-500 mt-0.5">{sub}</div>}
  </RCard>
);

/** Fetches a report whenever community/period/reload changes. */
export function useReport(path, tenantId, periodKey, customStart, customEnd, reloadKey) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!tenantId) return;
    let dead = false;
    (async () => {
      setLoading(true);
      const { start, end } = resolveRange(periodKey, customStart, customEnd);
      try {
        const { data } = await api.get(`/tenants/${tenantId}/reports/${path}`,
          { params: { start: start.toISOString(), end: end.toISOString() } });
        if (!dead) setData(data);
      } catch { /* toast handled by caller UI showing empty */ }
      finally { if (!dead) setLoading(false); }
    })();
    return () => { dead = true; };
  }, [tenantId, periodKey, reloadKey]); // eslint-disable-line
  return { data, loading };
}
